import htmlParser from 'html-react-parser';

export default function parse(s) {
  return htmlParser(s);
}
